import { getCurrentMagentoClient } from "@magento/clients/getClient";

import { useQuery } from "@jti/rest-api";

export const useBrandConsumablesMatrixQuery = () => {
  return useQuery({
    queryKey: ["BRAND_CONSUMABLES_MATRIX"],
    queryFn: () => getCurrentMagentoClient().getBrandConsumablesMatrix(),
  });
};
